import type {CSS} from '@pinecast/styles';
import * as React from 'react';

const Toggler = ({
  children,
  style,
}: {
  children: (prop: {
    open: boolean;
    toggle: (value?: boolean) => void;
    style?: CSS;
  }) => JSX.Element;
  style?: CSS;
}) => {
  const [open, setOpen] = React.useState<boolean>(false);
  return children({
    open,
    toggle: (value?: boolean) => setOpen(value !== undefined ? value : !open),
    style: style ?? {},
  });
};

export default Toggler;
